import React, { useMemo } from 'react';
import { ProviderProps } from '@app/shell/types';
import { isBrowser } from '@app/utils';

import HostContext from '../state/HostContext';

/**
 * We use memo here to ensure it runs on the server and client.
 *
 * @param children
 * @param req
 * @constructor
 */
const HostProvider = ({ children, req = undefined }: ProviderProps) => {
  //
  // Host
  const hostValue = useMemo(() => {
    if (isBrowser) {
      return `${window.location.protocol}//${window.location.host}`;
    }

    if (req?.headers?.host) {
      const hostname = req?.headers?.host;
      const protocol = req?.headers?.host?.startsWith('local')
        ? 'http'
        : 'https';

      return `${protocol}://${hostname}`;
    }

    return null;
  }, [req?.headers?.host]);

  return (
    <HostContext.Provider value={hostValue}>{children}</HostContext.Provider>
  );
};

export default HostProvider;
